import React, { useState } from "react";
import { useWebData } from "../context/WebDataContext";
import { auth } from "../firebaseConfig";
import { updatePassword, signOut } from "firebase/auth";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

function Profile() {
  const { currentUser } = useWebData();
  const [newPass, setNewPass] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 🔥 Change Password Logic
  const handleChangePassword = async () => {
    if (newPass.length < 6) return toast.error("Password must be 6+ chars");
    setLoading(true);
    try {
      if (auth.currentUser) {
        await updatePassword(auth.currentUser, newPass);
        toast.success("Password Updated Successfully! 🔒");
        setNewPass("");
      }
    } catch (e) {
      console.error(e);
      toast.error("Security Error: Please Logout & Login again to change password.");
    }
    setLoading(false);
  };

  // 🔥 Logout Logic
  const handleLogout = async () => {
      if(window.confirm("Are you sure you want to logout?")) {
          await signOut(auth);
          navigate("/login"); // Fixed: Should go to login, not just /
      }
  };

  // Helper for Initials
  const getInitials = (name) => {
      if(!name) return "U";
      const parts = name.split(" ");
      if(parts.length > 1) return (parts[0][0] + parts[1][0]).toUpperCase();
      return name[0].toUpperCase();
  };

  return (
    <div style={{ padding: "20px", fontFamily: "'Segoe UI', sans-serif", maxWidth: "800px", margin: "0 auto" }}>
      
      {/* 🔥 ADDED BACK BUTTON */}
      <button onClick={() => navigate(-1)} style={backBtnStyle}>
        ⬅ Back
      </button>

      <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"20px"}}>
          <h2 style={{ margin: 0, color: "#2c3e50" }}>👤 My Profile</h2>
          <button onClick={handleLogout} style={btnLogout}>🚪 Logout</button>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
        
        {/* LEFT: PROFILE CARD */}
        <div style={cardStyle}>
            <div style={headerBg}></div>
            <div style={avatarContainer}>
                <div style={avatar}>{getInitials(currentUser?.name)}</div>
            </div>
            
            <div style={{textAlign:"center", marginTop:"50px", paddingBottom:"20px"}}>
                <h2 style={{margin:"0", color:"#2c3e50"}}>{currentUser?.name}</h2>
                <p style={{margin:"5px 0", color:"gray", fontWeight:"500"}}>{currentUser?.role || "Employee"}</p>
                <div style={badgeStyle}>{currentUser?.empId || "ID: N/A"}</div>
            </div>

            <hr style={{border:"0.5px solid #eee", margin:"0 20px"}}/>

            <div style={{padding:"20px"}}>
                <div style={infoRow}>
                    <span>📧 Email</span>
                    <span style={{fontWeight:"bold"}}>{currentUser?.email}</span>
                </div>
                <div style={infoRow}>
                    <span>📞 Mobile</span>
                    <span style={{fontWeight:"bold"}}>{currentUser?.mobile || "-"}</span>
                </div>
                <div style={infoRow}>
                    <span>📅 Joined</span>
                    <span style={{fontWeight:"bold"}}>{currentUser?.joiningDate || "-"}</span>
                </div>
                <div style={infoRow}>
                    <span>📍 City</span>
                    <span style={{fontWeight:"bold"}}>{currentUser?.city || "-"}</span>
                </div>
            </div>
        </div>

        {/* RIGHT: DETAILS & SECURITY */}
        <div style={{display:"flex", flexDirection:"column", gap:"20px"}}>
            
            {/* WORK DETAILS */}
            <div style={cardStyle}>
                <h4 style={sectionTitle}>🏢 Work Details</h4>
                <div style={{padding:"0 20px 20px 20px"}}>
                    <div style={infoRow}>
                        <span>🎯 Monthly Target</span>
                        <span style={{color:"green", fontWeight:"bold"}}>₹ {Number(currentUser?.monthlyTarget || 0).toLocaleString()}</span>
                    </div>
                    <div style={infoRow}>
                        <span>🏖️ Yearly Leaves</span>
                        <span style={{color:"orange", fontWeight:"bold"}}>{currentUser?.yearlyLeaves || 0} / Year</span>
                    </div>
                    <div style={infoRow}>
                        <span>🏦 Bank</span>
                        <span style={{fontSize:"13px"}}>{currentUser?.bankDetails || "-"}</span>
                    </div>
                    <div style={{marginTop:"10px"}}>
                        <small style={{color:"gray"}}>Asset Notes:</small>
                        <p style={{background:"#f9f9f9", padding:"8px", borderRadius:"5px", fontSize:"13px", margin:"5px 0"}}>
                            {currentUser?.assetNotes || "No assets assigned."}
                        </p>
                    </div>
                </div>
            </div>

            {/* SECURITY */}
            <div style={cardStyle}>
                <h4 style={{...sectionTitle, borderBottom:"2px solid #c0392b", color:"#c0392b"}}>🔐 Security Settings</h4>
                <div style={{padding:"20px"}}>
                    <label style={{fontSize:"12px", fontWeight:"bold", color:"#555"}}>Change Password</label>
                    <div style={{display:"flex", gap:"10px", marginTop:"5px"}}>
                        <input 
                            type="password" 
                            placeholder="Enter new password" 
                            value={newPass} 
                            onChange={(e) => setNewPass(e.target.value)} 
                            style={inputStyle} 
                        />
                        <button 
                            onClick={handleChangePassword} 
                            disabled={loading}
                            style={btnUpdate}
                        >
                            {loading ? "..." : "Update"}
                        </button>
                    </div>
                    <p style={{fontSize:"11px", color:"gray", marginTop:"5px"}}>
                        * Note: If update fails, please logout and login again.
                    </p>
                </div>
            </div>

        </div>
      </div>
    </div>
  );
}

// STYLES
const backBtnStyle = {
    padding: "8px 15px",
    background: "#95a5a6",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginBottom: "15px", // Spacing below button
    fontSize: "14px",
    fontWeight: "bold"
};

const cardStyle = { background: "white", borderRadius: "10px", boxShadow: "0 4px 10px rgba(0,0,0,0.08)", overflow: "hidden" };
const headerBg = { height: "80px", background: "linear-gradient(to right, #2c3e50, #3498db)" };
const avatarContainer = { display: "flex", justifyContent: "center", marginTop: "-40px" };
const avatar = { width: "80px", height: "80px", borderRadius: "50%", background: "white", border: "4px solid white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "30px", fontWeight: "bold", color: "#2c3e50", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" };

const badgeStyle = { display:"inline-block", background:"#f0f2f5", padding:"4px 12px", borderRadius:"15px", fontSize:"12px", fontWeight:"bold", color:"#555", marginTop:"5px" };

const infoRow = { display: "flex", justifyContent: "space-between", borderBottom: "1px solid #f0f0f0", padding: "10px 0", fontSize: "14px", color: "#555" };
const sectionTitle = { margin: 0, padding: "15px 20px", borderBottom: "1px solid #eee", fontSize: "15px", color: "#2c3e50" };

const inputStyle = { padding: "10px", width: "100%", borderRadius: "5px", border: "1px solid #ccc", outline: "none" };
const btnUpdate = { padding: "10px 20px", background: "#c0392b", color: "white", border: "none", borderRadius: "5px", cursor: "pointer", fontWeight: "bold" };
const btnLogout = { padding: "8px 15px", background: "#e74c3c", color: "white", border: "none", borderRadius: "5px", cursor: "pointer", fontWeight:"bold", fontSize:"13px" };

export default Profile;